// extracted by mini-css-extract-plugin
export default {"bannerContainer":"HomeBanner_bannerContainer__yL9o1","bannerletterscroll":"HomeBanner_bannerletterscroll__dm5vF"};